/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

import Header from "~/sections/header"
import styled from "styled-components";
import LatestPosts from "~/components/latestPosts";
import { Row, Container } from "~/styles/Elements";

interface IProps {
  children: any
  location?: {
    pathname: string
  }
}

const Layout:React.SFC<IProps> = ({ children, location }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}

    render={data => (
      <>
        <Header location={location ? location.pathname : ''} siteTitle={data.site.siteMetadata.title} />
        <main>
          {children}
        </main>
        <Container>
          <Row>
            <LatestPosts></LatestPosts>
          </Row>
        </Container>
        <Footer>
          <Container>
            © {new Date().getFullYear()}, By <DAY4 href="https://day4">DAY4_</DAY4>
          </Container>
        </Footer>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

const Footer = styled.footer`
  border-top: 1px solid #999;
`

const DAY4 = styled.a`
  color: #000;
  text-decoration: none;
  font-family: serif;
  font-weight: 700;
`

export default Layout
